export default "__VITE_ASSET__f951865a__"